module.exports = __webpack_public_path__ + "img/MorenVesaas_Hverdagslykke.fc9c77df.jpg";